import { STATIC_TC } from "./staticContent"
import { normalizeComplianceItems } from "./complianceConfig"

const ORBIT_RINGS = ["a", "b", "b2", "c", "c2"]

const ICON_MAP = {
    Infrastructure: "gear",
    "Product security": "padlock-locked",
    "Data & privacy": "file-shield",
    "Access control": "key",
    Organizational: "person-group",
    Resilience: "shield-check",
}

function slugify(text) {
    return String(text || "")
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, "-")
        .replace(/(^-|-$)/g, "")
}

function mapControlsWidget(controlsWidget) {
    const categories = controlsWidget?.config?.categories
    if (!categories?.length) return STATIC_TC.defaultCategories

    return categories.map((cat) => ({
        id: slugify(cat.title),
        name: cat.title,
        icon: ICON_MAP[cat.title] || "shield-check",
        blurb: cat.blurb || cat.description || "",
        controls: (cat.items || []).map((item) => {
            if (typeof item === "string") return { name: item, desc: "" }
            const desc = item.description || ""
            return { name: item.label || item.name || "", desc }
        }),
    }))
}

function mapDocuments(apiDocuments) {
    if (!apiDocuments?.length) return []

    return apiDocuments.map((doc) => ({
        id: doc._id,
        name: doc.title,
        cat: doc.category || "General",
        icon: doc.accessTier === "public" ? "file-check" : "file-shield",
        gated: doc.accessTier !== "public",
        ext: "PDF",
        _apiDoc: doc,
    }))
}

function mapCompliances(widgets) {
    const compWidget = widgets?.find((w) => w.widgetName === "Compliances")
    if (!compWidget?.config) return []
    return normalizeComplianceItems(compWidget.config)
}


function mapFaqs(widgets) {
    const faqWidget = widgets?.find((w) => w.widgetName === "FAQ")
    const items = faqWidget?.config?.items
    if (!items?.length) return STATIC_TC.faqs

    const mapped = items
        .map((item) => ({
            q: item.q || item.question || "",
            a: item.a || item.answer || "",
        }))
        .filter((item) => item.q && item.a)

    return mapped.length ? mapped : STATIC_TC.faqs
}

function mapSubprocessors(widgets) {
    const spWidget = widgets?.find((w) => w.widgetName === "Subprocessors")
    const items = spWidget?.config?.items
    if (!items?.length) return STATIC_TC.subprocessors

    const mapped = items
        .map((item) => ({
            name: item.name || "",
            purpose: item.purpose || "",
            location: item.location || "",
            logoUrl: item.logoUrl || "",
            icon: item.icon || "link",
        }))
        .filter((item) => item.name && item.purpose)

    return mapped.length ? mapped : STATIC_TC.subprocessors
}

function mapOrbitIcons(widgets) {
    const heroWidget = widgets?.find((w) => w.widgetName === "Hero")
    const nodes = heroWidget?.config?.orbitNodes
    const source = nodes?.length ? nodes : STATIC_TC.defaultOrbitNodes

    return source.slice(0, ORBIT_RINGS.length).map((node, i) => ({
        ring: ORBIT_RINGS[i],
        icon: node.icon,
        label: node.label || "",
    }))
}

export function isWidgetVisible(widgets, widgetName) {
    const w = widgets?.find((item) => item.widgetName === widgetName)
    if (!w) return true
    return w.isVisible !== false
}

export function isHeroOrbitVisible() {
    return true
}

export function buildTrustCenterData({ documents = [], widgets = [], controls = null } = {}) {
    const certs = mapCompliances(widgets)
    return {
        ...STATIC_TC,
        certs,
        faqs: mapFaqs(widgets),
        subprocessors: mapSubprocessors(widgets),
        orbitIcons: mapOrbitIcons(widgets),
        showOrbit: true,
        categories: mapControlsWidget(controls),
        documents: mapDocuments(documents),
    }
}
